import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { StateToDefaultResetter } from "@platform-app/app/shared/common/store/state-to-default-resetter/state-to-default-resetter";
import {
  ResetOpportunitySetup,
  SetCurrentOpportunity,
} from "@platform-app/app/main/my-opportunities/shared/actions";
import { MyOpportunitiesStateModel } from "@platform-app/app/main/my-opportunities/shared/models";
import { DEFAULT_MY_OPPORTUNITIES_STATE } from "@platform-app/app/main/my-opportunities/shared/constants";

@State<MyOpportunitiesStateModel>({
  name: "MyOpportunities",
  defaults: DEFAULT_MY_OPPORTUNITIES_STATE,
})
@Injectable()
export class MyOpportunitiesState extends StateToDefaultResetter<MyOpportunitiesStateModel> {
  constructor() {
    super(DEFAULT_MY_OPPORTUNITIES_STATE);
  }

  @Selector()
  static currentOpportunityId(state: MyOpportunitiesStateModel) {
    return state.currentOpportunityId;
  }

  @Selector()
  static currentOpportunityTitle(state: MyOpportunitiesStateModel) {
    return state.currentOpportunityTitle;
  }

  @Selector()
  static duplicatedOpportunity(state: MyOpportunitiesStateModel) {
    return state.duplicatedOpportunity;
  }

  @Selector()
  static currentOpportunityReachedStatus(state: MyOpportunitiesStateModel) {
    return state.currentOpportunityReachedStatus;
  }

  @Selector()
  static currentOpportunityPublicStatus(state: MyOpportunitiesStateModel) {
    return state.currentOpportunityPublicStatus;
  }

  @Selector()
  static currentOpportunityType(state: MyOpportunitiesStateModel) {
    return state.currentOpportunityType;
  }

  @Selector()
  static currentMode(state: MyOpportunitiesStateModel) {
    return state.currentMode;
  }

  @Action(SetCurrentOpportunity)
  setCurrentOpportunity(
    ctx: StateContext<MyOpportunitiesStateModel>,
    action: SetCurrentOpportunity,
  ) {
    const state = ctx.getState();

    const {
      id,
      title = state.currentOpportunityTitle,
      opportunityType = state.currentOpportunityType,
      currentMode = state.currentMode,
      reachedStatus,
      duplicatedOpportunity = state.duplicatedOpportunity,
      publicStatus = state.currentOpportunityPublicStatus,
    } = action.payload;

    ctx.patchState({
      currentOpportunityId: id,
      currentOpportunityTitle: title,
      currentOpportunityReachedStatus: reachedStatus,
      currentOpportunityPublicStatus: publicStatus,
      currentOpportunityType: opportunityType,
      currentMode,
      duplicatedOpportunity,
    });
  }

  @Action(ResetOpportunitySetup)
  resetCurrentOpportunity(ctx: StateContext<MyOpportunitiesStateModel>) {
    ctx.setState(DEFAULT_MY_OPPORTUNITIES_STATE);
  }
}
